import styles from './OfferBox.module.css';

const OfferBox = ({ title, price, description }) => {
    return (
        <div className={styles.offerBox}>
            <div className={styles.titleWrapper}>
            <h2 className={styles.title}>{title}</h2>
            <h3 className={styles.price}>{price}</h3>
            </div>
            <p className={styles.description}>{description}</p>
        </div>
    );
}

export default OfferBox;